import { useTranslation } from "react-i18next";
import { NavLink } from "react-router-dom";
import { ScrollArea, Title } from "@mantine/core";
import { useNetwork } from "@mantine/hooks";

import { StyledWrapper } from "@layouts/WithPatientNavbar/WithPatientNavbar.styled";

import { NetworkNotification } from "@components/NetworkNotification";

import {
  getAdminDashboardNavLinks,
  getStaffDashboardNavLinks,
} from "@data/dashboardNavLinks";

import { ROLES } from "@constants/index";

import { useAuth } from "@contexts/auth";

import { StyledWithDashboardNavbar } from "./WithDashboardNavbar.styled";


interface WithDashboardNavbarProps {
  children: React.ReactNode;
  userRole: "staff" | "admin";
}

export const WithDashboardNavbar = ({
  children,
  userRole,
}: WithDashboardNavbarProps) => {
  const { t } = useTranslation();

  const { roles , canAccessPath } = useAuth();

  const { online } = useNetwork();

  return (
    <>
      <NetworkNotification />
      <StyledWithDashboardNavbar
        className={`${!online ? "show-notification" : "hide-notification"}`}>
        <div className="upper-nav">
          <Title order={2} fz={22} fw={500}>
            {t("dashboard")}
          </Title>
        </div>

        <ScrollArea>
          {userRole === ROLES.ADMIN && (
            <ul className="nav-links">
              {getAdminDashboardNavLinks().map(
                ({ id, label, value, isEnabled }) => (
                  <li
                    className={`nav-links-item ${!isEnabled ? "disabled" : ""}`}
                    key={id}>
                    <NavLink to={`/dashboard/admin/${value}`}>{label}</NavLink>
                  </li>
                )
              )}
            </ul>
          )}

          {userRole === "staff" && (
            <ul className="nav-links">
              {getStaffDashboardNavLinks(canAccessPath).map(
                ({ id, label, value, isEnabled }) => (
                  <li
                    className={`nav-links-item ${!isEnabled ? "disabled" : ""}`}
                    key={id}>
                    <NavLink to={`/dashboard/staff/${value}`}>{label}</NavLink>
                  </li>
                )
              )}
            </ul>
          )}
        </ScrollArea>
      </StyledWithDashboardNavbar>
      <StyledWrapper
        className={`${!online ? "show-notification" : "hide-notification"}`}>
        {children}
      </StyledWrapper>
    </>
  );
};
